// extracted by mini-css-extract-plugin
export default {"main":"SocialLinks_main__rsUa7"};